import React from 'react'
import styled from '@emotion/styled'
import { Filter } from 'lucide-react'

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props: any) => props.theme.colors?.white || '#ffffff'};
  border: 1px solid
    ${(props: any) => props.theme.colors?.borderColor || '#e2e8f0'};
  border-radius: 10px;
  height: 40px;
  padding: 0 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    border-color: ${(props: any) => props.theme.colors?.blue500 || '#004aad'};
  }

  &:focus-within {
    border-color: ${(props: any) => props.theme.colors?.blue500 || '#004aad'};
    box-shadow: 0 0 0 3px rgba(0, 74, 173, 0.1);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

const IconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  margin-right: 8px;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 2.5;
  }
`

const StyledSelect = styled.select`
  border: none;
  outline: none;
  background: transparent;
  color: ${(props: any) => props.theme.colors?.text || '#334155'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  appearance: none;
  padding-right: 15px; /* space for custom arrow if needed */
  font-family: inherit;
  width: 100%;
  min-width: 100px;

  option {
    color: ${(props: any) => props.theme.colors?.text || '#334155'};
    background-color: ${(props: any) => props.theme.colors?.white || '#ffffff'};
    font-weight: normal;
  }
`

const ArrowIcon = styled.div`
  position: relative;
  right: 5px;
  pointer-events: none;
  color: #64748b;
  font-size: 10px;
  display: flex;
  align-items: center;
`

export interface StatusFilterProps {
  value?: string
  onChange?: (status: string) => void
  options?: { label: string; value: string }[]
  placeholder?: string
}

const defaultOptions = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Delivered', value: 'Delivered' },
  { label: 'Cancelled', value: 'Cancelled' },
]

const StatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  options = defaultOptions,
  placeholder = 'Filter Status',
}) => {
  return (
    <FilterContainer>
      <IconButton>
        <Filter />
      </IconButton>
      <StyledSelect
        value={value || ''}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
      <ArrowIcon>▼</ArrowIcon>
    </FilterContainer>
  )
}

export default StatusFilter
